module.exports = __webpack_public_path__ + "img/comics.fffb575c.svg";